import styled from 'styled-components';

export const StyledContainer = styled.div`
    img {
        border-radius: 0px !important;
        height: 100% !important;
    }
    .align-center {
        align-items: center;
    }
`;

export const StyledButton = styled.button`
    background-color: #09e5ab;
    color: #fff;
    border: 1px solid #09e5ab;
    margin-top: 20px;
    padding: 12px 25px;
    border-radius: 5px;
    font-weight: 700;
    cursor: pointer;
    margin-left: auto;
`;